module.exports = __webpack_public_path__ + "static/Earth.72972dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Galaxy/images/Earth.png
// module id = 335
// module chunks = 168707334958949